import React, { useState, useEffect } from "react";
import "./Carousel.css";

const Carousel = ({ images, interval = 5000, isHomePage = false }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, interval);

    return () => clearInterval(slideInterval);
  }, [images.length, interval]);

  return (
    <div className={isHomePage ? "carousel home-page-carousel" : "carousel"}>
      {images.map((image, index) => (
        <div
          key={index}
          className={`carousel-image ${index === currentIndex ? "active" : ""}`}
          style={{ backgroundImage: `url(${image})` }}
        ></div>
      ))}
    </div>
  );
};

export default Carousel;
